/* eslint-disable jsx-a11y/anchor-is-valid */

import React, {useEffect, useMemo, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useLocation, useNavigate} from 'react-router-dom'
import './StaffAccountList.scss'
import ReactPaginate from 'react-paginate'
import moment from 'moment'
import axios from 'axios'
import {KTSVG, toAbsoluteUrl, useDebounce} from '../../../../../_metronic/helpers'
import DeleteConfirmationPopup from '../../../../Components/DeleteConfirmationPopup'
import {ProfileDetailData} from '../../../../Redux/AdminPanel/ProfileDetailsSlice'
import CreateStaffAccountPopup from './Modal/CreateStaffAccountPopup'
import {
  UpdateStatusStaff,
  GetAllStaff,
  GetAllStaffForStaffAdmin,
  DeleteStaffAccount,
  ExportStaffAccountList,
} from './StaffAccountSlice/StaffAccountSlice'
import {AuthenticateUser} from '../../../../Utils/_helpers/RoleAndPermission'
import {Dropdown} from 'react-bootstrap'
import {getAccountIdList, GetAllAccountId} from '../../AllCellCastUser/UserListSlice/UserListSlice'
import {StatusColor} from '../../../../Utils/Constant/ArrayOfSideNav'
import {GeneralDataOFLoginUser} from '../../../../Utils/Auth'
import {RoleName} from '../../../../Utils/Constant/ConstantForWebsite'
import Select from 'react-select'
import NodataYet from '../../../../Components/NodataYet'

const StaffAccountList = () => {
  ///////////////////////////All Constants/////////////////////////////////////////////
  const param = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const isUserWhiteLabel = GeneralDataOFLoginUser()?.isWhiteLabelUser === true

  /////////////////////////////////////USE STATE/////////////////////////////////
  const [subUser, setSubUser] = useState(false)
  const [checkList, setCheckList] = useState<any>([])
  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState<any>(false)
  const [deleteIds, setDeleteIds] = useState<any>()
  const [csvDownload, setCsvDownload] = useState<any>([])
  const accountIdList = useSelector(getAccountIdList)
  const [apply, setApply] = useState(false)
  const [filterOpen, setFilterOpen] = useState(false)
  const [filter, setFilter] = useState<any>({
    status: {value: '', label: 'Select Status'},
    accountId: {value: '', label: 'Select Account'},
  })
  const [page, setPage] = useState({
    page: 1,
    size: 10,
    search: '',
  })

  /////////////////////////////////////////USE SELECTOR /////////////////////////////////////

  const stafflist = useSelector((state: any) => state?.StaffAccount?.staffAccountList)
  const debouncedSearchTerm = useDebounce(page?.search, 500)

  /////////////////////////////USE EFFECT//////////////////////////////////////////
  useEffect(() => {
    if (!isUserWhiteLabel) {
      dispatch(GetAllAccountId())
    }
  }, [])
  useEffect(() => {
    let filterData = {
      status: filter?.status?.value,
      accountId: filter?.accountId?.value,
    }
    dispatch(
      GetAllStaff({
        page: {...filterData, ...page},
      })
    )
  }, [debouncedSearchTerm, page.page, page.size, filter, apply])

  //IF get confirmation from popup it will delete
  useEffect(() => {
    if (confirm == true) {
      dispatch(
        DeleteStaffAccount({
          userIds: deleteIds,
          page: page,
        })
      )
      setConfirm(false)
    }
  }, [confirm])

  ///////////////////////////////////////////////////////CUSTOM FUNCTION///////////////////////////////
  const handleCheckAll = () => {
    if (checkList?.length == stafflist?.items?.length) {
      setCheckList([])
    } else {
      let list = stafflist?.items?.map((key: any) => key._id)
      setCheckList([...list])
    }
  }

  const handleCheck = (e: any) => {
    if (checkList?.includes(e.target.value)) {
      checkList.splice(checkList?.indexOf(e.target.value), 1)

      setCheckList([...checkList])
    } else {
      setCheckList([...checkList, e.target.value])
    }
  }

  const handleSelect = (id: any, e: any) => {
    setOpen(true)
    setDeleteIds([id])
  }

  const handleDeleteAll = () => {
    setOpen(true)
    setDeleteIds(checkList)
  }

  const handleExport = () => {
    dispatch(ExportStaffAccountList({page: page, checkList: checkList}))
  }
  ///////////////////////////////////////////////////USE MEMO//////////////////////////////////////
  const popup = useMemo(
    () => (
      <CreateStaffAccountPopup filter={page} show={subUser} handleClose={() => setSubUser(false)} />
    ),
    [subUser]
  )
  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={open}
        handleClose={() => setOpen(false)}
        Message={'Are you sure, you want to delete this staff?'}
        confirm={() => setConfirm(true)}
      />
    ),
    [open]
  )

  return (
    <>
      {confirmation}
      {popup}
      {
        <div className={`sub-accountstable card`}>
          <div className='card-header border-0 pt-5'>
            {AuthenticateUser('delete-staff') && (
              <div className='card-toolbar  mb-1'>
                {checkList?.length > 0 && (
                  <>
                    <div className='fw-bolder pe-8'>
                      <span className='me-2'>{checkList?.length}</span> Selected
                    </div>
                    <button type='button' className='btn btn-danger' onClick={handleDeleteAll}>
                      Delete Selected
                    </button>
                  </>
                )}
              </div>
            )}

            <div
              className='card-toolbar'
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              data-bs-trigger='hover'
              title='Click to add a user'
            >
              <div className='d-flex align-items-center position-relative my-1'>
                <KTSVG
                  path='/media/icons/duotune/general/gen021.svg'
                  className='svg-icon-1 position-absolute ms-6'
                />
                <input
                  type='text'
                  data-kt-user-table-filter='search'
                  className='form-control form-control-solid w-250px ps-14'
                  placeholder='Search user'
                  value={page?.search}
                  onChange={(e) => setPage({...page, search: e.target.value, page: 1, size: 10})}
                />
              </div>
              <div
                onMouseEnter={() => setFilterOpen(true)}
                onMouseLeave={() => setFilterOpen(false)}
                className='filter_parent'
              >
                <button
                  className={`btn btn-light-primary ms-3 me-3 filter_btn ${
                    filterOpen && 'show menu-dropdown'
                  } `}
                  data-kt-menu-placement='bottom-end'
                >
                  <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2' />
                  Filter
                </button>

                <div
                  className={`menu menu-sub menu-sub-dropdown w-250px w-md-300px ${
                    filterOpen && 'show filtermenu'
                  }`}
                >
                  <div className='px-7 py-5'>
                    <div className='mb-10'>
                      <label className='form-label fw-bold'>Status:</label>

                      <div>
                        <Select
                          value={filter.status}
                          onChange={(e: any) =>
                            setFilter({...filter, status: e, page: 1, size: 10})
                          }
                          className='form-select form-select-solid fw-bolder'
                          placeholder={'Select status'}
                          options={[
                            {value: 'active', label: 'Active'},
                            {value: 'inactive', label: 'Inactive'},

                            {value: 'suspended', label: 'Suspended'},
                          ]}
                        />
                        {/* <select
                          value={page?.status}
                          name='status'
                          onChange={(e: any) => setPage({...page, status: e.target.value})}
                          className='form-select form-select-solid fw-bolder'
                        >
                          <option value=''>Select Status</option>
                          <option value='active'> Active </option>
                          <option value='inactive'> Inactive </option>
                          <option value='suspended'> Suspended </option>
                        </select> */}
                      </div>
                    </div>
                    {!isUserWhiteLabel && (
                      <div className='mb-10'>
                        <label className='form-label fw-bold'>AccountId:</label>

                        <div>
                          <Select
                            value={filter.accountId}
                            className='form-select form-select-solid fw-bolder'
                            name='accountId'
                            onChange={(e: any) =>
                              setFilter({...filter, accountId: e, page: 1, size: 10})
                            }
                            options={accountIdList?.map((key: any) => ({
                              value: key?._id,
                              label: key?.companyName,
                            }))}
                          />
                          {/* <select
                            value={page?.accountId}
                            name='accountId'
                            onChange={(e: any) => setPage({...page, accountId: e.target.value})}
                            className='form-select form-select-solid fw-bolder'
                          >
                            <option value=''>Select AccountId</option>
                            {accountIdList?.map((key: any) => (
                              <option key={key?._id} value={key?._id}>
                                {key?.companyName}
                              </option>
                            ))}
                          </select> */}
                        </div>
                      </div>
                    )}

                    <div className='d-flex justify-content-end'>
                      <button
                        type='reset'
                        className='btn btn-sm btn-white btn-active-light-primary me-2'
                        onClick={() => {
                          setPage({
                            page: 1,
                            size: 10,
                            search: '',
                          })
                          setFilter({
                            status: {value: '', label: 'Select Status'},
                            accountId: {value: '', label: 'Select Account'},
                          })
                        }}
                      >
                        Reset
                      </button>

                      <button
                        type='submit'
                        className='btn btn-sm btn-primary'
                        data-kt-menu-dismiss='true'
                        onClick={() => {
                          setApply(!apply)
                          setFilterOpen(false)
                        }}
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {AuthenticateUser('export-staff') && (
                <button onClick={handleExport} type='button' className='btn btn-light-primary me-3'>
                  <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
                  Export
                </button>
              )}

              {AuthenticateUser('create-staff') && (
                <button type='button' className='btn btn-primary' onClick={() => setSubUser(true)}>
                  <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                  Create Staff
                </button>
              )}
            </div>
          </div>
          {stafflist?.items?.length > 0 ? (
            <div className='card-body py-3'>
              <div className='table-responsive'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead>
                    <tr className='fw-bolder text-muted'>
                      <th className='w-25px'>
                        <div className='form-check form-check-sm form-check-custom form-check-solid'>
                          <input
                            className='form-check-input'
                            type='checkbox'
                            value='1'
                            data-kt-check='true'
                            data-kt-check-target='.widget-9-check'
                            checked={checkList?.length >= stafflist?.items?.length}
                            onChange={handleCheckAll}
                          />
                        </div>
                      </th>
                      <th className='min-w-150px'>USER</th>
                      <th className='min-w-140px'>ROLE</th>
                      <th className='min-w-140px'>STATUS</th>
                      <th className='min-w-120px'>LAST LOGIN</th>
                      <th className='min-w-100px'>JOINED-DATE</th>
                      <th className='min-w-100px text-end'>ACTIONS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {stafflist?.items?.map((data: any, i: number) => (
                      <tr key={i}>
                        <td>
                          <div className='form-check form-check-sm form-check-custom form-check-solid'>
                            <input
                              className='form-check-input widget-9-check'
                              type='checkbox'
                              value={data?._id}
                              checked={checkList?.includes(data?._id)}
                              onChange={handleCheck}
                            />
                          </div>
                        </td>
                        <td>
                          <div
                            onClick={() => {
                              if (AuthenticateUser('edit-staff')) {
                                dispatch(ProfileDetailData(data?._id))
                                navigate(`/staff-profile`)
                              }
                            }}
                            className='d-flex align-items-center'
                          >
                            <div className='symbol symbol-45px me-5 cursor-pointer'>
                              {data?.avatar && data?.avatar !== 'undefined' ? (
                                <img src={data?.avatar} alt='' />
                              ) : (
                                <span className='circle1'>{`${data?.firstName
                                  ?.split('')[0]
                                  ?.toUpperCase()}${
                                  data?.lastName !== undefined && data?.lastName !== ''
                                    ? data?.lastName?.split('')[0]?.toUpperCase()
                                    : ''
                                }`}</span>
                              )}
                            </div>
                            <div className='d-flex justify-content-start flex-column'>
                              <a className='text-dark fw-bolder text-hover-primary fs-6'>
                                {`${data?.firstName} ${
                                  data?.lastName !== undefined ? data?.lastName : ''
                                }`}
                              </a>
                              <span className='text-muted fw-bold text-muted d-block fs-7'>
                                {data?.email}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <a className='text-dark fw-bolder text-hover-primary d-block fs-6'>
                            {RoleName?.[data?.role]}
                          </a>
                        </td>
                        <td>
                          <span
                            className={`'px-2 py-1 badge badge-light-${
                              StatusColor?.[data?.status2]
                            }`}
                          >
                            {data?.status2?.toUpperCase()}
                          </span>
                        </td>
                        <td>
                          <a className='text-dark fw-bolder text-hover-primary d-block fs-6'>
                            {moment(data?.lastLogin).fromNow()}
                          </a>
                        </td>

                        <td>
                          <a className='text-dark fw-bolder text-hover-primary d-block fs-6'>
                            {moment(data?.createdAt).format('DD/MM/YYYY')}
                          </a>
                        </td>
                        <td className='text-end'>
                          <span
                            className='btn btn-light btn-active-light-primary btn-sm'
                            data-kt-menu-trigger='click'
                            data-kt-menu-placement='bottom-end'
                          >
                            Actions
                            <KTSVG
                              path='/media/icons/duotune/arrows/arr072.svg'
                              className='svg-icon-5 m-0'
                            />
                          </span>
                          <div
                            className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4'
                            data-kt-menu='true'
                          >
                            {/* begin::Menu item */}
                            {AuthenticateUser('edit-staff') && (
                              <div className='menu-item px-3'>
                                <span
                                  className='menu-link px-3'
                                  onClick={() => {
                                    if (AuthenticateUser('edit-staff')) {
                                      dispatch(ProfileDetailData(data?._id))
                                      navigate(`/staff-profile`)
                                    }
                                  }}
                                >
                                  Edit
                                </span>
                              </div>
                            )}
                            {/* end::Menu item */}

                            {/* begin::Menu item */}
                            {AuthenticateUser('delete-staff') && (
                              <div className='menu-item px-3'>
                                <span
                                  className='menu-link px-3'
                                  data-kt-users-table-filter='delete_row'
                                  onClick={(e: any) => handleSelect(data?._id, e)}
                                >
                                  Delete
                                </span>
                              </div>
                            )}
                            {AuthenticateUser('edit-staff') && (
                              <div
                                className='menu-item px-3'
                                data-kt-menu-trigger='hover'
                                data-kt-menu-placement='right-end'
                              >
                                <span className='menu-link'>
                                  <span className='menu-title'>Status</span>
                                  <span className='menu-arrow' />
                                </span>
                                <div className='menu-sub menu-sub-dropdown w-175px py-4'>
                                  <div
                                    className='menu-item px-3'
                                    onClick={() => {
                                      dispatch(
                                        UpdateStatusStaff({
                                          page,
                                          data: {
                                            userId: data?._id,
                                            status2: 'active',
                                          },
                                        })
                                      )
                                    }}
                                  >
                                    <span className='menu-link px-3'>
                                      <span className='bg-success   rounded-circle border border-4 border-white h-20px w-20px'></span>
                                      <span className='menu-title'>Active</span>
                                      {data?.status2 == 'active' && (
                                        <span className='svg-icon svg-icon-primary'>
                                          <svg
                                            xmlns='http://www.w3.org/2000/svg'
                                            xmlnsXlink='http://www.w3.org/1999/xlink'
                                            width='24px'
                                            height='24px'
                                            viewBox='0 0 24 24'
                                            version='1.1'
                                          >
                                            <g
                                              stroke='none'
                                              strokeWidth={1}
                                              fill='none'
                                              fillRule='evenodd'
                                            >
                                              <polygon points='0 0 24 0 24 24 0 24' />
                                              <path
                                                d='M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z'
                                                fill='#7950f2'
                                                fillRule='nonzero'
                                                transform='translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002)'
                                              />
                                            </g>
                                          </svg>
                                        </span>
                                      )}
                                    </span>
                                  </div>
                                  <div
                                    className='menu-item px-3'
                                    onClick={() => {
                                      dispatch(
                                        UpdateStatusStaff({
                                          page,
                                          data: {
                                            userId: data?._id,
                                            status2: 'inactive',
                                          },
                                        })
                                      )
                                    }}
                                  >
                                    <span className='menu-link px-3'>
                                      <span className='bg-secondary   rounded-circle border border-4 border-white h-20px w-20px'></span>
                                      <span className='menu-title'>Inactive</span>

                                      {data?.status2 == 'inactive' && (
                                        <span className='svg-icon svg-icon-primary'>
                                          <svg
                                            xmlns='http://www.w3.org/2000/svg'
                                            xmlnsXlink='http://www.w3.org/1999/xlink'
                                            width='24px'
                                            height='24px'
                                            viewBox='0 0 24 24'
                                            version='1.1'
                                          >
                                            <g
                                              stroke='none'
                                              strokeWidth={1}
                                              fill='none'
                                              fillRule='evenodd'
                                            >
                                              <polygon points='0 0 24 0 24 24 0 24' />
                                              <path
                                                d='M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z'
                                                fill='#7950f2'
                                                fillRule='nonzero'
                                                transform='translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002)'
                                              />
                                            </g>
                                          </svg>
                                        </span>
                                      )}
                                    </span>
                                  </div>
                                  <div
                                    className='menu-item px-3'
                                    onClick={() => {
                                      dispatch(
                                        UpdateStatusStaff({
                                          page,
                                          data: {
                                            userId: data?._id,
                                            status2: 'suspended',
                                          },
                                        })
                                      )
                                    }}
                                  >
                                    <span className='menu-link px-3'>
                                      <span className='bg-danger   rounded-circle border border-4 border-white h-20px w-20px'></span>
                                      <span className='menu-title'>Suspended</span>

                                      {data?.status2 == 'suspended' && (
                                        <span className='svg-icon svg-icon-primary'>
                                          <svg
                                            xmlns='http://www.w3.org/2000/svg'
                                            xmlnsXlink='http://www.w3.org/1999/xlink'
                                            width='24px'
                                            height='24px'
                                            viewBox='0 0 24 24'
                                            version='1.1'
                                          >
                                            <g
                                              stroke='none'
                                              strokeWidth={1}
                                              fill='none'
                                              fillRule='evenodd'
                                            >
                                              <polygon points='0 0 24 0 24 24 0 24' />
                                              <path
                                                d='M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z'
                                                fill='#7950f2'
                                                fillRule='nonzero'
                                                transform='translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002)'
                                              />
                                            </g>
                                          </svg>
                                        </span>
                                      )}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}
                            {/* end::Menu item */}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className='abcd '>
                  <select onChange={(e: any) => setPage({...page, size: e.target.value, page: 1})}>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={stafflist?.total}>ALL</option>
                  </select>
                  <ReactPaginate
                    previousLabel='<'
                    nextLabel='>'
                    pageCount={stafflist?.totalPages}
                    onPageChange={(e) => setPage({...page, page: e.selected + 1})}
                    containerClassName={'pagiantion'}
                    previousLinkClassName={'pagination__link'}
                    nextLinkClassName={'pagination__link'}
                    disabledClassName={'pagination__link--disabled'}
                    activeClassName={'pagination__link--active'}
                  />
                </div>
              </div>
            </div>
          ) : (
            <NodataYet />
          )}
        </div>
      }
    </>
  )
}

export default StaffAccountList
